var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.715 167.004v284.952c0 26.534-21.51 48.044-48.044 48.044h-296.28c-26.534 0-48.044-21.51-48.044-48.044v-391.912c0-26.534 21.51-48.044 48.044-48.044h198.441z",
    fill: "#b26024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.714 167.004h-113.853c-17.689 0-32.029-14.34-32.029-32.029v-122.974z",
    fill: "#713708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.888 427.607h-371.403c-5.081 0-9.2-4.119-9.2-9.2v-168.324c0-5.081 4.119-9.2 9.2-9.2h371.403c5.081 0 9.2 4.119 9.2 9.2v168.324c0 5.081-4.119 9.2-9.2 9.2z",
    fill: "#713708"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.982 382.919c-1.47 0-3.097-.313-4.786-.938-1.72-.626-3.097-1.47-4.16-2.502-1.063-1.001-1.595-2.19-1.595-3.597 0-.313.031-.782.156-1.439l31.873-103.751c.626-1.939 2.002-3.378 4.066-4.348 2.096-.97 4.285-1.439 6.662-1.439 2.44 0 4.723.469 6.787 1.439 2.096.97 3.441 2.408 4.097 4.348l31.718 103.751c.188.657.313 1.126.313 1.439 0 1.282-.563 2.471-1.689 3.534s-2.502 1.939-4.16 2.565-3.284.938-4.879.938c-1.408 0-2.596-.25-3.597-.782-1.032-.532-1.752-1.439-2.189-2.721l-6.568-22.74h-39.693l-6.412 22.74c-.313 1.282-1.032 2.19-2.158 2.721-1.128.532-2.379.782-3.786.782zm16.202-39.849h32.029l-16.015-54.925z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.318 287.957c-2.69 0-4.973-.876-6.881-2.69-1.939-1.814-2.878-3.879-2.878-6.131 0-2.44.938-4.504 2.878-6.224 1.908-1.72 4.191-2.565 6.881-2.565 2.659 0 4.942.845 6.787 2.565 1.877 1.72 2.815 3.785 2.815 6.224 0 2.252-.938 4.316-2.815 6.131-1.845 1.814-4.128 2.69-6.787 2.69zm0 94.962c-2.471 0-4.473-.563-6.005-1.752-1.564-1.189-2.315-2.44-2.315-3.816v-64.871c0-1.626.751-2.94 2.315-3.941 1.533-1.001 3.534-1.501 6.005-1.501 2.346 0 4.348.5 6.005 1.501 1.658 1.001 2.471 2.315 2.471 3.941v64.872c0 1.376-.813 2.627-2.471 3.816-1.657 1.188-3.659 1.751-6.005 1.751z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai.f198f4e23b4ac1b168d21b7656d80c85.svg";